import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import eitsApi from '@/apis/eitsApi';
import LoginPageLayout from '@/views/Layout/LoginPageLayout.vue';

var ForgetPassword = /*#__PURE__*/function (_Vue) {
  _inherits(ForgetPassword, _Vue);

  var _super = _createSuper(ForgetPassword);

  function ForgetPassword() {
    _classCallCheck(this, ForgetPassword);

    return _super.apply(this, arguments);
  }

  _createClass(ForgetPassword, [{
    key: "forgetBack",
    value: function forgetBack(payload) {
      if (payload.type === 'success') {
        this.$router.push({
          name: 'ResetPassword',
          params: {
            verifyCode: payload.verifyCode,
            productCode: payload.productCode,
            name: payload.phoneNo.replace(/-/g, '')
          }
        });
      }
    }
  }, {
    key: "checkPhoneUrl",
    get: function get() {
      return eitsApi.PHONE_STATUS_SDK;
    }
  }, {
    key: "getCodeUrl",
    get: function get() {
      return eitsApi.PHONE_VERIFY_CODE_SDK;
    }
  }, {
    key: "checkCodeUrl",
    get: function get() {
      return eitsApi.CHECK_CODE_SDK;
    }
  }, {
    key: "productCode",
    get: function get() {
      // return ''
      return this.$store.getters.userInfo.productCode;
    }
  }]);

  return ForgetPassword;
}(Vue);

ForgetPassword = __decorate([Component({
  components: {
    LoginPageLayout: LoginPageLayout
  }
})], ForgetPassword);
export default ForgetPassword;